import { render } from "./BsfpAttendanceView.vue?vue&type=template&id=c2baa322&scoped=true"
import script from "./BsfpAttendanceView.vue?vue&type=script&lang=js"
export * from "./BsfpAttendanceView.vue?vue&type=script&lang=js"

import "./BsfpAttendanceView.vue?vue&type=style&index=0&id=c2baa322&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2baa322"]])

export default __exports__